import KeywordHighlight from './KeywordHighlight'
import searchTokenize from './SearchTokenize'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

@searchTokenize
export default class RichText extends Component {
  static propTypes = {
    text: PropTypes.string,
    tokens: PropTypes.array
  }

  render() {
    const { text, tokens } = this.props

    return (
      <div className="rich-text-container">
        <KeywordHighlight text={text} tokens={tokens} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/RichText.js